import React, { memo } from 'react';
import {
  StyledProductImage,
  StyledRowProduct,
  StyledCardContent,
  StyledCardItems,
} from '../index.style';
import EyeBrow from '../../eyeBrow/eyeBrow';

type Props = {
  products: {
    quantity: string;
    pictures: { small: string }[];
    genericName: string;
  }[];
};

const ProductList = ({ products }: Props) => {
  return (
    <>
      {products?.length > 0 && (
        <StyledCardContent>
          <StyledRowProduct>
            {products.map(
              (item: {
                quantity: string;
                pictures: { small: string }[];
                genericName: string;
              }) => {
                return (
                  <StyledCardItems>
                    <StyledProductImage>
                      <img
                        src={item?.pictures[0]?.small}
                        alt={item?.genericName}
                        title={item?.genericName}
                        id="img-productlist-picture"
                      />
                    </StyledProductImage>
                    <EyeBrow
                      color="default"
                      label={item.quantity}
                      variant="filled"
                      id="lbl-productlist-quantity"
                    />
                  </StyledCardItems>
                );
              }
            )}
          </StyledRowProduct>
        </StyledCardContent>
      )}
    </>
  );
};

export default memo(ProductList);
